import React, { useEffect, useRef, useState, memo } from 'react'
import './SelectBox.scss'

const SelectBox = (props) => {
  const { dropdownOption, selectedValue, setSelectedValue, setValue, disabled, className } = props
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const ref = useRef()
  useEffect(() => {
    function handleClickOutside (event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])

  const toggleDropdown = () => {
    setIsDropdownOpen(prevState => !prevState)
  }

  const handleOptionClick = (key, value) => {
    setSelectedValue(value)
    setValue(key)
  }
  return (
    <div className={`custom-select-box ${disabled ? 'disabled' : ''}`}>
      <div
        ref={ref} className={`select-el ${className} ${isDropdownOpen ? 'expanded' : ''}`} onClick={toggleDropdown}
      >
        <span>{selectedValue}</span>

        {dropdownOption.map((item) => item !== selectedValue && (
          <span
            key={item.key}
            onClick={() => handleOptionClick(item.key, item.value)}
          >
            {item.value}
          </span>
        ))}
      </div>
    </div>
  )
}
export default memo(SelectBox)
